
import {Component, Vue} from 'vue-property-decorator'
import getDate from "@/views/company/getDate"
import newDatePicker from "@/components/DatePicker/newDatePicker.vue";
import dayjs from "dayjs";

@Component({
    name: 'MoreFilter',
    components: {newDatePicker}
})
export default class MoreFilter extends Vue {
    pageType = '1' // 1订货单 2退货单
    params = {
        orderType: '', // 下单方式 || 退单方式
        status: '', // 付款状态 || 退款状态
        timeActive: 0,
        startTime: '',
        endTime: ''
    }
    showMoreFilter = false
    showCalendar = false
    showcomfirm = false
    defaultDate = null
    minDate = new Date(dayjs().subtract(10, 'year').format("YYYY-MM-DD")) // 默认10年前
    maxDate = new Date(dayjs().add(10, 'year').format("YYYY-MM-DD")) // 默认10年后
    maxHeight = document.documentElement.clientHeight - 220 + "px"

    // 订货单的更多筛选
    orderTypeOptions: Array<any> = [
        {text: '全部', value: ''},
        {text: '自主下单', value: 1},
        {text: '代客下单', value: 2}
    ]

    statusOptions: Array<any> = [
        {text: '全部', value: ''},
        {text: '未付款', value: 1},
        {text: '已付款', value: 2}
    ]
    timeOptions: Array<any> = [
        {text: '近60天', value: 0},
        {text: '近7天', value: 1},
        {text: '本月', value: 2},
        {text: '上月', value: 3},
        {text: '本季度', value: 4},
        {text: '上季度', value: 5},
        {text: '本年', value: 6},
        {text: '去年', value: 7},
        {text: '自定义', value: 8},
    ]

    created() {
        let query = this.$route.query
        this.pageType = query.pageType as string
        this.params.orderType = query.orderType as string
        this.params.status = query.status as string
        this.params.timeActive = Number(this.$route.query.timeActive)
        if (this.params.timeActive === 0) {
            this.params.startTime = dayjs().subtract(60, 'days').format('YYYY-MM-DD')
            this.params.endTime = dayjs().format("YYYY-MM-DD")
        } else {
            this.params.startTime = this.$route.query.startTime as string
            this.params.endTime = this.$route.query.endTime as string
            this.showcomfirm = true
        }
        this.defaultDate = [new Date(this.params.startTime), new Date(this.params.endTime)]

        // 退货单的更多筛选
        if (this.pageType == '2') {
            this.orderTypeOptions = [
                {text: '全部', value: ''},
                {text: '自主退单', value: 1},
                {text: '代客退单', value: 2}
            ]
            this.statusOptions = [
                {text: '全部', value: ''},
                {text: '退款中', value: 1},
                {text: '已退款', value: 2}
            ]
        }
    }


    get isshowcomfirm () {
      return this.showcomfirm
    }

    selectcheck (date) {
      const [start, end] = date
      if (start !== null && end !== null) {
        this.showcomfirm = true
      } else {
        this.showcomfirm = false
      }
    }

    onConfirmData () {
      const [start, end] = (this.$refs.timeDate as any).currentDate
      this.defaultDate = (this.$refs.timeDate as any).currentDate
      this.params.startTime = dayjs(start).format("YYYY-MM-DD");
      this.params.endTime = dayjs(end).format("YYYY-MM-DD");
      // this.expectDate = `${dayjs(start).format("YYYY/MM/DD")} - ${dayjs(
      //   end
      // ).format("YYYY/MM/DD")}`;
      this.showCalendar = false
    }

    show(data) {
      this.showMoreFilter = true
      this.pageType = data.pageType as string
      this.params.orderType = data.orderType as string
      this.params.status = data.status as string
      this.params.timeActive = Number(data.timeActive)
      if (this.params.timeActive === 0) {
          this.params.startTime = dayjs().subtract(60, 'days').format('YYYY-MM-DD')
          this.params.endTime = dayjs().format("YYYY-MM-DD")
      } else {
          this.params.startTime = data.startTime as string
          this.params.endTime = data.endTime as string
          this.showcomfirm = true
      }
      this.defaultDate = [new Date(this.params.startTime), new Date(this.params.endTime)]
      console.log('123', this.defaultDate)

      // 退货单的更多筛选
      if (this.pageType == '2') {
          this.orderTypeOptions = [
              {text: '全部', value: ''},
              {text: '自主退单', value: 1},
              {text: '代客退单', value: 2}
          ]
          this.statusOptions = [
              {text: '全部', value: ''},
              {text: '退款中', value: 1},
              {text: '已退款', value: 2}
          ]
      }
    }

    // 重置
    resetFunc() {
        this.params.orderType = ''
        this.params.status = ''
        this.params.timeActive = 0
        this.params.startTime = ''
        this.params.endTime = ''
        this.handleTimeOptions(0)
    }
    // 修改时间筛选选中
    changeActive () {
      this.params.timeActive = 8
    }
    /**
     * @description: 时间类型选择事件
     * @param {*} type
     * @return {*}
     */
    handleTimeOptions(type) {
      if (type == 8) this.showCalendar = true
        this.params.timeActive = type
        let days
        switch (type) {
            // 全部(近6个月)
            case 0:
                this.params.startTime = dayjs().subtract(60, 'days').format('YYYY-MM-DD')
                this.params.endTime = dayjs().format("YYYY-MM-DD")
                break
            case 6:
                days = getDate.getCurrYearDays()
                break;
            // 近7天
            case 1:
                days = getDate.getLastSevenDays()
                break;
            // 本月
            case 2:
                days = getDate.getCurrMonthDays()
                break;
            // 上月
            case 3:
                days = getDate.getLastMonthDays()
                break;
            // 本季度
            case 4:
                days = getDate.getCurrQuarterDays()
                break;
            // 上季度
            case 5:
                days = getDate.getLastQuarterDays()
                break;
            // 去年
            case 7:
                days = getDate.getLastYearDays()
                break;
            // 自定义
            case 8:
                break
        }
        if (days) {
            this.params.startTime = days.starttime
            this.params.endTime = days.endtime
        }
    }
    // 自定义时间选择系列方法
    /**
     * @description: 获取开始时间
     * @param {*} val
     * @return {*}
     */
    getStartTime(val: string) {
        this.params.startTime = val
    }

    /**
     * @description: 获取结束时间
     * @param {*} val
     * @return {*}
     */
    getEndTime(val: string) {
        this.params.endTime = val
    }

    /**
     * @description: 下单方式/退单方式选择事件
     * @param {*}
     * @return {*}
     */
    handleOrderTypeOptions(type) {
        this.params.orderType = type
    }

    /**
     * @description: 付款状态/退款状态选择事件
     * @param {*}
     * @return {*}
     */
    handleStatusOptions(type) {
        this.params.status = type
    }

    /**
     * @description: 关闭事件
     * @param {*}
     * @return {*}
     */
    cancel() {
        this.showMoreFilter = false
    }
    /**
     * @description: 确定按钮事件
     * @param {*}
     * @return {*}
     */
    confirm() {
        this.showMoreFilter = false
        this.$eventBus.$emit('moreFilter', this.params)
    }
}
